import {z} from 'zod';

export const TireDictionarySchema = z.object({
  name: z.string().nonempty(),
});
